import { useParams } from "react-router-dom";
import useUserProfile from "../hooks/useUserProfile";
import userPhoto from "../assets/def_profile_photo.png";

function UserProfile() {
  const { username } = useParams();
  const [userProfile, error] = useUserProfile(username);

  return (
    <div className="dashboard-profile-page">
      {error && <p className="error-message">Something went wrong...</p>}
      {userProfile && (
        <div className="profile">
          <div className="avatar-wrap">
            <img
              alt="a bowl of noodles"
              className="user-photo"
              src={userPhoto}
            />
            <h1>{userProfile.username}</h1>
          </div>

          <div className="profile-section">
            {userProfile.favorite_food && (
              <div class="profile-field">
                <h3 className="profile-field-label">Favourite Dish</h3>
                <span>🍽️ {userProfile.favorite_food}</span>
              </div>
            )}

            {userProfile.ask_me_about && (
              <div className="profile-field">
                <h3 className="profile-field-label">Ask Me About</h3>
                <span>{userProfile.ask_me_about}</span>
              </div>
            )}

            {userProfile.bio && (
              <div className="profile-field">
                <h3 className="profile-field-label">Bio</h3>
                <span>{userProfile.bio}</span>
              </div>
            )}

            {userProfile.spice_level && (
              <div className="profile-field">
                <h3 className="profile-field-label">Spice Level</h3>
                <div className="chips">
                  <span className="chip chip--display">
                    {userProfile.spice_level}
                  </span>
                </div>
              </div>
            )}

            {userProfile.cuisines?.length > 0 && (
              <div className="profile-field">
                <h3 className="profile-field-label">Favourite Cuisines</h3>
                <div className="chips">
                  {userProfile.cuisines.map((c) => (
                    <span key={c.id} className="chip chip--display">
                      {c.title}
                    </span>
                  ))}
                </div>
              </div>
            )}

            {(userProfile.gender || userProfile.age_range) && (
              <div className="profile-field">
                <h3 className="profile-field-label">About</h3>
                <div className="chips">
                  {userProfile.gender && (
                    <span className="chip chip--display">
                      {userProfile.gender.charAt(0).toUpperCase() +
                        userProfile.gender.slice(1)}
                    </span>
                  )}
                  {userProfile.age_range && (
                    <span className="chip chip--display">
                      {userProfile.age_range}
                    </span>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default UserProfile;
